<template>
  <div>
    <div class="table-scroll mb-2">
      <table class="points" style="width:100%; border-collapse:collapse;">
        <thead>
          <tr>
            <th v-for="c in cols" :key="c.key" style="text-align:left;padding:8px;border-bottom:1px solid #ddd">{{ c.label }}</th>
            <th style="text-align:right;padding:8px;border-bottom:1px solid #ddd">Leitura (mSv/sem)</th>
            <th style="width:80px;padding:8px;border-bottom:1px solid #ddd"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in rows" :key="row.id || idx">
            <td v-for="c in cols" :key="c.key" style="padding:6px;border-bottom:1px solid #eee">
              <input
                :type="c.type || 'text'"
                :value="formatCalc(row[c.key])"
                @input="onInput(idx, c.key, $event)"
                style="width:100%;padding:6px;border:1px solid #ccc;border-radius:4px"
              />
            </td>
            <td class="calc" style="padding:6px;border-bottom:1px solid #eee;text-align:right">
              {{ formatCalc(calcForRow(row)) }}
            </td>
            <td style="padding:6px;border-bottom:1px solid #eee;text-align:center">
              <button class="rm-btn" @click.prevent="removeRow(idx)">−</button>
            </td>
          </tr>
          <tr v-if="!(rows && rows.length)">
            <td :colspan="cols.length + 2" class="empty-state">No rows</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="table-count">{{ rows.length }} rows</div>
      <div>
        <b-button size="sm" variant="outline-primary" @click="$emit('add')">Add</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'MyRadiometryTable',
  components: { BButton },
  props: {
    rows: {
      type: Array,
      default() {
        return []
      },
    },
    cols: {
      type: Array,
      default() {
        return []
      },
    },
    calcFn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    colsFields() {
      // fields array for b-table; attach metadata on rows per-field
      return this.cols.map(c => ({
        key: c.key,
        label: c.label,
      }))
    },
  },
  watch: {},
  methods: {
    // onInput(index, field, value) {
    //   // already reactive via v-model on localRows
    // },
    removeRow(idx) {
      const next = (this.rows || []).slice()
      next.splice(idx, 1)
      this.$emit('update:rows', next)
    },
    onInput(idx, key, ev) {
      const val = ev && ev.target ? ev.target.value : ev
      const next = (this.rows || []).slice()
      next[idx] = { ...(next[idx] || {}), [key]: val }
      this.$emit('update:rows', next)
    },
    calcForRow(row, field) {
      try {
        if (this.calcFn) return this.calcFn(row, field)
        // default: sum numeric fields in row
        return Object.keys(row).reduce((s, k) => {
          const n = parseFloat(row[k])
          return s + (Number.isFinite(n) ? n : 0)
        }, 0)
      } catch (e) { return '' }
    },
    formatCalc(v) {
      if (v === null || v === undefined || v === '') return ''
      return typeof v === 'number' ? v.toFixed(4) : v
    },
  },
}
</script>

<style scoped>
.table-scroll{overflow-x:auto}
.table-count{font-size:12px;color:#666}
table.points{min-width:1200px}
table.points input{min-width:120px}
</style>
